import React from 'react'
import Edit from '../crud/edit'
import Action from './action'
import fields from './fields'
import menuItems from './menuItems'
import { Tabs, Tab } from 'material-ui/Tabs'
import MembershipStatus from './memberships'

const EditUser = (props) => {
  return (
    <Tabs>
      <Tab label='Edit User'>
        <Edit
// @ts-ignore
          title='Editing User'
          fields={fields}
          apiPath={`admin/users/${props.params.userId}`}
          successRedirectPath='/security/users'
          buildMenuItems={menuItems}
        />
      </Tab>
      <Tab label='Customer Service'>
        <Action
// @ts-ignore
          title='Customer Service Operations on User'
          apiPath={`admin/users/${props.params.userId}`}
          successRedirectPath='/security/users'
          buildMenuItems={menuItems}
        />
      </Tab>
      <Tab label='Membership'>
        <MembershipStatus
          userId={props.params.userId}
        />
      </Tab>
    </Tabs>
  )
}

export default EditUser
